import React from 'react';
import styled from 'styled-components';

import { Box } from 'rebass';
import { T } from 'containers';
import { AppText } from 'domain/appText';

import { GlowHeading } from 'components';

const StyledBox = styled(Box)`
  background-color: #fff;
  color: #294666;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0px;
  font-size: 14px;
  text-align: left;

  .inner{
    background-color: #fdd;
    padding: 40px;
    border: 1px solid #f2aab3;

    h1{
      color: #804040;
      font-size: 17px;
      line-height: 1.2em;
      display: inline-block;
      vertical-align: middle;
      width: calc(100% - 55px);
    }
  }

  img{
    width: 40px;
    height: auto;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
`;

const SelectCabinAllCabinsNotPopulated = () => (
  <T
    text={[
      AppText.CabinDistributionEmptyCabin,
    ]}
    render={([
          cabinDistributionEmptyCabin,
        ]) => (
          <StyledBox>
            <div className="inner">
              <img src="/assets/images/error.svg" alt="Error" />
              <GlowHeading f={3}>{cabinDistributionEmptyCabin}</GlowHeading>
            </div>
          </StyledBox>
        )}
  />
);
export default SelectCabinAllCabinsNotPopulated;



// WEBPACK FOOTER //
// ./src/components/organisms/SelectCabinAllCabinsNotPopulated/index.js